export const CARRIER_NAMES = { royal_mail: "Royal Mail", dpd: "DPD", evri: "Evri", dhl: "DHL", ups: "UPS", fedex: "FedEx", parcelforce: "Parcelforce", yodel: "Yodel", other: "Outra", own_delivery: "Entrega própria" };

export function orderMode(o) {
  if (o?.fulfilment_mode === "delivery" || o?.fulfilment_mode === "pickup") return o.fulfilment_mode;
  return (Array.isArray(o?.items) ? o.items : []).some((it) => it?.fulfilment_mode === "delivery") ? "delivery" : "pickup";
}

const BASE = { pending: "Aguarda pagamento", paid: "Pago", processing: "Em preparação", ready: "Pronto para levantar", shipped: "Enviado",
  completed: "Concluído", cancelled: "Cancelado", refunded: "Reembolsado", partially_refunded: "Reembolso parcial", disputed: "Em disputa" };

export function statusLabel(o) {
  const st = o?.status;
  if (st === "completed" && orderMode(o) === "delivery") return "Entregue";
  return BASE[st] || st || "—";
}

export const STEPS = {
  delivery: [["paid", "Pago"], ["processing", "Em preparação"], ["shipped", "Enviado"], ["completed", "Entregue"]],
  pickup: [["paid", "Pago"], ["processing", "Em preparação"], ["ready", "Pronto para levantar"], ["completed", "Concluído"]],
};

export function stepIndex(o) {
  const steps = STEPS[orderMode(o)];
  const i = steps.findIndex(([s]) => s === o?.status);
  if (i >= 0) return i;
  if (["cancelled", "refunded"].includes(o?.status)) return -1;
  return 0;
}

export const fmtDT = (d) => (d && !Number.isNaN(Date.parse(d)) ? new Date(d).toLocaleString("pt-PT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

export function hostOf(url) {
  try { return new URL(url).hostname.replace(/^www\./, ""); } catch { return ""; }
}

export function addressLines(a) {
  if (!a || a.redacted) return [];
  return [a.name, a.line1, a.line2, [a.city, a.postal_code].filter(Boolean).join(" "), a.country === "GB" ? "Reino Unido" : a.country].filter(Boolean);
}
